/* eslint-disable no-return-await */
import { callGetExternalApi } from '../utils/externalApiCall';
import generateBackendUrl from '../constants/api.routes.constants';

const getCSV = async (csv, isDownload, headers = {}) => {
  const response = await callGetExternalApi({
    url: generateBackendUrl(csv, isDownload).GET_DOCUMENT,
    headers,
  });
  return response;
};

const checkReno = async () => {
  const response = await callGetExternalApi({ url: generateBackendUrl().SERVIDOR_RENO });
  return response;
};

const getValidacion = async (csv, headers = {}) => {
  const response = await callGetExternalApi({
    url: generateBackendUrl(csv).GET_VALIDATION,
    headers,
  });
  return response;
};

const downloadSignedCopy = async (csv, headers = {}) => {
  const response = await callGetExternalApi({
    url: generateBackendUrl(csv).GET_SIGNED_COPY,
    headers,
  });
  return response;
};

// eslint-disable-next-line import/prefer-default-export
export { getCSV, checkReno, getValidacion, downloadSignedCopy };
